<template>
  <div class="row mb-1">
    <div class="col-3">
      <label :for="'textbausteinName-' + index" class="form-label fw-bold">Name</label>
      <input type="text" class="form-control" :id="'textbausteinName-' + index" v-model="textbaustein.name" required />
    </div>

    <div class="col-3" v-if="index == -1">
      <label :for="'textbausteinGruppe-' + index" class="form-label fw-bold">Gruppe</label>
      <input type="text" class="form-control" :id="'textbausteinGruppe-' + index" v-model="textbaustein.gruppe" />
    </div>

    <div class="col offset-1">
      <label :for="'textbaustein-infotext-' + index" class="form-label fw-bold">Infotext</label>
      <textarea class="form-control" :id="'textbaustein-infotext-' + index" rows="2" v-model="textbaustein.infotext"></textarea>
    </div>
  </div>

  <div class="row mb-3" v-if="index == -1">
    <div class="col">
      <input class="form-check-input me-2" type="checkbox" :id="'textbaustein-issignaturbaustein-' + index" v-model="textbaustein.isSignaturBaustein" />
      <label class="form-check-label" :for="'textbaustein-issignaturbaustein-' + index"> Signatur Paragraph?</label>
    </div>
  </div>

  <section>
    <nav>
      <div class="nav nav-tabs" id="nav-tabs" role="tablist">
        <button
          class="nav-link active"
          :id="'nav-tab-deutsch-' + index"
          data-bs-toggle="tab"
          :data-bs-target="'#nav-deutsch-' + index"
          type="button"
          role="tab"
          :aria-controls="'nav-deutsch-' + index"
          aria-selected="true"
        >
          Deutsch
        </button>

        <button
          class="nav-link"
          :id="'nav-tab-english-' + index"
          data-bs-toggle="tab"
          :data-bs-target="'#nav-english-' + index"
          type="button"
          role="tab"
          :aria-controls="'nav-english-' + index"
          aria-selected="false"
        >
          Englisch
        </button>

        <button
          class="nav-link"
          :id="'nav-tab-deutsch-english-' + index"
          data-bs-toggle="tab"
          :data-bs-target="'#nav-deutsch-english-' + index"
          type="button"
          role="tab"
          :aria-controls="'nav-deutsch-english-' + index"
          aria-selected="false"
        >
          Deutsch/Englisch
        </button>
      </div>
    </nav>

    <div class="tab-content" id="nav-content">
      <!-- DEUTSCH -->
      <div class="tab-pane fade show active" :id="'nav-deutsch-' + index" role="tabpanel" :aria-labelledby="'nav-tab-deutsch-' + index" tabindex="0">
        <div v-if="checkEnglischVersionNotification" class="alert alert-warning my-3 text-center">
          <p class="m-0">Die deutsche Version wurde geändert. Bitte prüfen Sie die englische Version.</p>
        </div>

        <div class="row mx-0 mt-4">
          <div class="col-4 offset-4">
            <label :for="'textbausteinTitel-' + index" class="form-label"><strong>Überschrift</strong> (optional)</label>
            <input type="text" class="form-control" :id="'textbausteinTitel-' + index" v-model="textbaustein.titel" />
          </div>
        </div>

        <TextEditor2 v-model="textbaustein.text" />
      </div>

      <!-- ENGLISCH -->
      <div class="tab-pane fade" :id="'nav-english-' + index" role="tabpanel" :aria-labelledby="'nav-tab-english-' + index" tabindex="1">
        <div v-if="checkGermanVersionNotification" class="alert alert-warning my-3 text-center">
          <p class="m-0">Die englische Version wurde geändert. Bitte prüfen Sie die deutsche Version.</p>
        </div>

        <div class="row mx-0 mt-4">
          <div class="col-4 offset-4">
            <label :for="'textbausteinTitel-' + index" class="form-label"><strong>Überschrift</strong> (optional)</label>
            <input type="text" class="form-control" :id="'textbausteinTitel-' + index" v-model="textbaustein.titelEN" />
          </div>
        </div>

        <TextEditor2 v-model="textbaustein.textEN" />
      </div>

      <div class="tab-pane fade" :id="'nav-deutsch-english-' + index" role="tabpanel" :aria-labelledby="'nav-tab-deutsch-english-' + index" tabindex="2">
        <div class="row mx-0 my-2">
          <div class="col-6 p-2 border-end">
            <p class="text-center"><strong>Deutsch</strong></p>

            <div v-if="checkEnglischVersionNotification" class="alert alert-warning my-3 text-center">
              <p class="m-0">Die deutsche Version wurde geändert. Bitte prüfen Sie die englische Version.</p>
            </div>

            <div class="row mx-0 mt-4">
              <div class="col-4 offset-4">
                <label :for="'textbausteinTitel-' + index" class="form-label"><strong>Überschrift</strong> (optional)</label>
                <input type="text" class="form-control" :id="'textbausteinTitel-' + index" v-model="textbaustein.titel" />
              </div>
            </div>

            <TextEditor2 v-model="textbaustein.text" />
          </div>

          <div class="col-6 p-2 border-start">
            <p class="text-center"><strong>Englisch</strong></p>

            <div v-if="checkGermanVersionNotification" class="alert alert-warning my-3 text-center">
              <p class="m-0">Die englische Version wurde geändert. Bitte prüfen Sie die deutsche Version.</p>
            </div>

            <div class="row mx-0 mt-4">
              <div class="col-4 offset-4">
                <label :for="'textbausteinTitel-' + index" class="form-label"><strong>Überschrift</strong> (optional)</label>
                <input type="text" class="form-control" :id="'textbausteinTitel-' + index" v-model="textbaustein.titelEN" />
              </div>
            </div>

            <TextEditor2 v-model="textbaustein.textEN" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, computed } from 'vue';
  import { Textbaustein } from '@/models/VorlageModels';

  import TextEditor2 from '../TextEditor/TextEditor2.vue';
  //#endregion;

  const { textbaustein, originalTextbaustein, index } = defineProps({
    textbaustein: {
      type: Object as PropType<Textbaustein>,
      required: true,
    },
    originalTextbaustein: {
      type: Object as PropType<Textbaustein>,
      required: true,
    },
    index: {
      type: Number,
      default: -1,
    },
  });

  //#region Text Changed Notification
  const checkEnglischVersionNotification = computed(() => {
    if (originalTextbaustein.textEN != undefined && originalTextbaustein.textEN.length > 0) {
      if (textbaustein.text !== originalTextbaustein.text && textbaustein.textEN === originalTextbaustein.textEN) {
        return true;
      }
    }

    return false;
  });

  const checkGermanVersionNotification = computed(() => {
    if (originalTextbaustein.text != undefined && originalTextbaustein.text.length > 0) {
      if (textbaustein.text === originalTextbaustein.text && textbaustein.textEN !== originalTextbaustein.textEN) {
        return true;
      }
    }

    return false;
  });
  //#endregion
</script>
